// src/i18n/index.js — Detección de idioma del usuario

/**
 * getUserLang
 * Detecta el idioma preferido del navegador.
 * @returns {'es'|'en'}
 */
export function getUserLang() {
  const nav = navigator.language || navigator.userLanguage || 'es';
  return nav.toLowerCase().startsWith('es') ? 'es' : 'en';
}

/**
 * t — Translate helper
 * Lee la clave del objeto de traducciones.
 * @param {object} translations - objeto de idioma activo
 * @param {string} key          - clave (e.g. 'capture.title')
 * @param {object} [vars]       - variables para interpolación {name}
 * @returns {string}
 */
export function t(translations, key, vars = {}) {
  const parts = key.split('.');
  let val = translations;
  for (const part of parts) {
    val = val?.[part];
    if (val === undefined) return key;
  }
  if (typeof val !== 'string') return key;
  return val.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? `{${k}}`);
}
